// extracted by mini-css-extract-plugin
module.exports = {"label":"_1PjXvmQ","checkbox":"_2g9rBgj","disabled":"_3WZaA7K","labelError":"_NF9C88h","checkboxError":"_1qzSqrB","root":"_MCcZ6Mx"};